export enum ScreenType{
    popup = 'popup',
    page = 'page'
}